// DersDinle Asistan — kişiselleştirilmiş asistan için varsayılan profil verileri.
// Gerçek kullanıcı bilgisi olmadığında gösterilen örnek profiller ve hızlı öneriler.

// DersDinle Asistan'ın anime maskotu (site temasına uygun teal/turkuaz).
export const assistantAvatar =
  "https://readdy.ai/api/search-image?query=A%20cheerful%20cute%20chibi%20anime%20mascot%2C%20a%20friendly%20young%20study%20assistant%20girl%20with%20bright%20teal%20turquoise%20hair%20in%20twin%20tails%2C%20large%20sparkling%20cyan%20eyes%2C%20gentle%20warm%20smile%2C%20wearing%20a%20teal%20and%20white%20uniform%20with%20a%20small%20open%20book%20badge%2C%20waving%20one%20hand%20hello%2C%20soft%20rounded%20kawaii%20face%2C%20clean%20smooth%20lineart%2C%20soft%20cell%20shading%2C%20simple%20flat%20pastel%20teal%20turquoise%20circular%20background%20with%20subtle%20glowing%20sparkles%2C%20vibrant%20friendly%20colors%2C%20centered%20head%20and%20shoulders%20portrait%2C%20high%20quality%20digital%20illustration%20for%20a%20learning%20app%20avatar&width=400&height=400&seq=asistan-mascot-v1&orientation=squarish";

export type CoachRole = "ogrenci" | "veli" | "ogretmen" | "admin" | "guest";

export interface AiCoachProfile {
  name: string;
  role: CoachRole;
  roleLabel: string;
  grade: string;
  exam: string;
  city: string;
  childName: string;
  childGrade: string;
  subjects: string[];
  goal: string;
}

export const aiCoachProfiles: Record<CoachRole, AiCoachProfile> = {
  ogrenci: {
    name: "Elif Yılmaz",
    role: "ogrenci",
    roleLabel: "Öğrenci",
    grade: "8. Sınıf",
    exam: "LGS",
    city: "İstanbul",
    childName: "",
    childGrade: "",
    subjects: ["Matematik", "Fen Bilimleri", "Türkçe"],
    goal: "Fen Lisesi hedefi",
  },
  veli: {
    name: "Ayşe Kaya",
    role: "veli",
    roleLabel: "Veli",
    grade: "",
    exam: "LGS",
    city: "İstanbul",
    childName: "Elif",
    childGrade: "8. Sınıf",
    subjects: [],
    goal: "Çocuğunun LGS sürecini takip etmek",
  },
  ogretmen: {
    name: "Mehmet Demir",
    role: "ogretmen",
    roleLabel: "Öğretmen",
    grade: "",
    exam: "",
    city: "Ankara",
    childName: "",
    childGrade: "",
    subjects: ["Matematik", "Geometri"],
    goal: "Öğrencilerinin başarısını artırmak",
  },
  admin: {
    name: "Selin Yıldız",
    role: "admin",
    roleLabel: "Yönetici",
    grade: "",
    exam: "",
    city: "İstanbul",
    childName: "",
    childGrade: "",
    subjects: [],
    goal: "Platformu yönetmek",
  },
  guest: {
    name: "Ziyaretçi",
    role: "guest",
    roleLabel: "Ziyaretçi",
    grade: "",
    exam: "",
    city: "",
    childName: "",
    childGrade: "",
    subjects: [],
    goal: "Platformu keşfetmek",
  },
};

export const aiCoachQuickPrompts: Record<CoachRole, string[]> = {
  ogrenci: [
    "Bugün ne çalışmalıyım?",
    "Matematikte eksiğim var",
    "Denemeye nasıl hazırlanayım?",
    "Fen'de hangi konu önemli?",
    "Netlerimi nasıl artırırım?",
    "Moralim bozuk",
  ],
  veli: [
    "Çocuğumun durumu nasıl?",
    "Haftalık raporu yorumla",
    "Evde nasıl destek olayım?",
    "Ödevlerini yaptı mı?",
  ],
  ogretmen: [
    "Sınıfımın analizini çıkar",
    "Test nasıl oluştururum?",
    "Bir öğrencim geriledi",
  ],
  admin: [
    "Aktif kullanıcı sayısı",
    "Yeni paket nasıl eklerim?",
    "Destek taleplerini gör",
  ],
  guest: [
    "Platform nasıl çalışıyor?",
    "Ücretsiz deneme var mı?",
    "Hangi paketler var?",
    "LGS hazırlığı nedir?",
  ],
};